import axiosInstance from '../axiosInstance';
import { toast } from 'react-toastify';
import { DEFAULT_PRICE_TYPE_NAME } from './contact-price-type';

export const fetchDefaultCustomerPriceTypeName = async (customerCode, lineName) => {
  const code = String(customerCode ?? '').trim();
  const line = String(lineName ?? '').trim();
  if (!code || !line) return '';

  try {
    const response = await axiosInstance.get('/api/levels/getDefaultCustomerPriceType', {
      params: { customerCode: code, lineName: line },
    });
    return response.data?.data || DEFAULT_PRICE_TYPE_NAME;
  } catch (error) {
    console.error(error);
    toast.error(error.response?.data?.message || error.message);
    return DEFAULT_PRICE_TYPE_NAME;
  }
};
